import { QueryHookOptions } from '@apollo/client'
import B2C_GET_CHECKOUT_SESSION from '@graphql/queries/getCarpayCheckoutSession.query'
import { B2CGetCheckoutSessionQuery, B2CGetCheckoutSessionQueryVariables } from 'parkdepot-shared/gql/graphql'
import { useAuthenticatedQuery } from './useAuth'

const useGetCheckoutSession = (
    opts: QueryHookOptions<B2CGetCheckoutSessionQuery, B2CGetCheckoutSessionQueryVariables>
) => {
    return useAuthenticatedQuery({ query: B2C_GET_CHECKOUT_SESSION, ...opts })
}

export default useGetCheckoutSession
